// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"24d0bb20","551":"de29278b"}[chunkId] + ".chunk.js";
};